import { apiRoot } from './apiInstances';

export interface EmailSendRequest {
  estimateId: number;
  to: string;
  cc?: string;
  bcc?: string;
  subject?: string;
  senderEmail?: string;
  senderName?: string;
  customMessage?: string;
  includeCustomMessage?: boolean;
  pdfBuffer: string; // base64 encoded
  companyInfo: {
    name: string;
    address: string;
    city: string;
    state: string;
    zip: string;
    phone: string;
    email: string;
    website?: string;
  };
}

export interface EmailConfig {
  host: string;
  port: number;
  secure: boolean;
  auth: {
    user: string;
    pass: string;
  };
}

export class EmailService {
  static async sendEstimateEmail(data: EmailSendRequest): Promise<{ success: boolean; message: string }> {
    try {
      const response = await apiRoot.post(`/email/send-estimate`, data);
      return response.data;
    } catch (error: any) {
      console.error('Send email error:', error);
      throw new Error(
        error.response?.data?.message || 'Failed to send email'
      );
    }
  }

  static async configureEmail(config: EmailConfig): Promise<{ success: boolean; message: string }> {
    try {
      const response = await apiRoot.post(`/email/configure`, config);
      return response.data;
    } catch (error: any) {
      console.error('Configure email error:', error);
      throw new Error(
        error.response?.data?.message || 'Failed to configure email'
      );
    }
  }

  static async testConnection(): Promise<{ success: boolean; message: string }> {
    try {
      const response = await apiRoot.post(`/email/test-connection`, {});
      return response.data;
    } catch (error: any) {
      console.error('Test connection error:', error);
      throw new Error(
        error.response?.data?.message || 'Failed to test email connection'
      );
    }
  }

  static async getEmailConfig(): Promise<{
    host: string;
    port: number;
    secure: boolean;
    hasAuth: boolean;
  }> {
    try {
      const response = await apiRoot.get(`/email/config`);
      return response.data;
    } catch (error: any) {
      console.error('Get email config error:', error);
      throw new Error(
        error.response?.data?.message || 'Failed to get email configuration'
      );
    }
  }
}